import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCookieState: ICookieState = {
  data: {
    cookie: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface ICookieState {
  data?: {
    cookie?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICookieState = initialCookieState,
  action: ActionWithPayload<ICookieState>
) => {
  switch (action.type) {
    case actionTypes.GET_COOKIE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_COOKIE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_COOKIE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_COOKIE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_COOKIE_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_COOKIE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_COOKIE_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_COOKIE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_COOKIE_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_COOKIE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_COOKIE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_COOKIE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_COOKIE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_COOKIE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_COOKIE_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_COOKIE_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_COOKIE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_COOKIE_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_COOKIE_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_COOKIE_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_COOKIE_SUCCESS: {
      return {
        ...state,
        sortCookieData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_COOKIE_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_COOKIE_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortCookieData: [],
      }
    }

    default:
      return state
  }
}
